"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAll = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const orm_metrics_api_1 = require("../utils/api/orm-metrics/orm-metrics.api");
const initialState = {
    overview: null,
    series: [],
    byEndpoint: [],
    slow: [],
    status: 'idle',
};
exports.loadAll = (0, toolkit_1.createAsyncThunk)('metrics/loadAll', (params) => __awaiter(void 0, void 0, void 0, function* () {
    const [o, s, b, q] = yield Promise.all([
        (0, orm_metrics_api_1.fetchOverview)(params),
        (0, orm_metrics_api_1.fetchTimeseries)(params),
        (0, orm_metrics_api_1.fetchByEndpoint)(params),
        (0, orm_metrics_api_1.fetchSlowQueries)(params)
    ]);
    return { o, s, b, q };
}));
const metricsSlice = (0, toolkit_1.createSlice)({
    name: 'metrics',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(exports.loadAll.pending, (state) => { state.status = 'loading'; state.error = undefined; })
            .addCase(exports.loadAll.fulfilled, (state, action) => {
            state.status = 'idle';
            state.overview = action.payload.o;
            state.series = action.payload.s;
            state.byEndpoint = action.payload.b;
            state.slow = action.payload.q;
        })
            .addCase(exports.loadAll.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        });
    }
});
exports.default = metricsSlice.reducer;
